"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditText = exports.AmountText = exports.UpperViewContainer = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.UpperViewContainer = native_1.default.View `
  padding-left: 16px;
  padding-right: 16px;
  justify-content: center;
  align-items: center;
`;
exports.AmountText = native_1.default.Text `
  text-align: center;
  font-size: 32px;
  color: ${(props) => props.theme.text.color.primary}};
  padding-top: 60px;
`;
exports.CreditText = native_1.default.Text `
  text-align: center;
  font-size: 16px;
  color: ${(props) => props.theme.bottomNavigation.disabled.text};
  padding-top: 10px;
`;
